export default __webpack_public_path__ + "static/media/icon_menuarrow.9e02dd9f.png";